export class Cache {
	public cacheName: string;
	memoryStoreObjectCount: number;
	hits?: number;
	misses?: number;
	puts?: number;
}
